import { render } from "./produto.vue?vue&type=template&id=0136df7a"
import script from "./produto.vue?vue&type=script&lang=js"
export * from "./produto.vue?vue&type=script&lang=js"

import "./produto.vue?vue&type=style&index=0&id=0136df7a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__